/**
 * Layout and styling constants for the Stock Request form
 * These values are used for sticky footer, error panel positioning, and spacing
 */

// Layout measurements
export const LAYOUT_CONSTANTS = {
	// Footer dimensions
	footerHeight: 72, // 16px padding top + 40px button + 16px padding bottom
	footerPaddingVertical: 16,
	footerPaddingHorizontal: 24,

	// Error panel positioning
	errorPanelPaddingVertical: 16,
	errorPanelPaddingHorizontal: 24,

	// Content spacing
	contentPadding: 24,
	contentBottomPadding: 88, // footerHeight (72px) + extra breathing room (16px)

	// Button sizing
	minCancelButtonWidth: 150,
	minSubmitButtonWidth: 200,
} as const

// Z-index management
export const Z_INDEX = {
	dropdown: 100,
	modal: 500,
	stickyFooter: 1000,
	stickyErrorPanel: 1000,
	toast: 2000,
} as const
